enum SalesTotalTypeEnum {
    DAILY = "daily",
    WEEKLY = "weekly",
    MONTHLY = "monthly",
    YEARLY = "yearly",
}

export default SalesTotalTypeEnum;
